import { useField } from 'formik';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';

interface ImageFieldWithAvatarProps {
  label?: string;
  name: string;
  disabled?: boolean;
  hint?: string;
  avatarName?: string;
}

const ImageFieldWithAvatar = (props: ImageFieldWithAvatarProps) => {
  const { label, name, disabled, hint, avatarName } = props;
  const [field, meta, helpers] = useField(name);
  const [thumb, setThumb] = useState(field.value);
  useEffect(() => {
    setThumb(field.value);
  }, [field.value]);

  const handleImageChange = (event) => {
    const reader = new FileReader();
    const file = event.target.files[0];

    // on new upload overwrite thumb to read file image
    if (file) {
      reader.onloadend = () => setThumb(reader.result);
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="ImageFieldWithAvatar form-group">
      <Row>
        <Col>
          <div>
            <label htmlFor={name}>{label || ''}</label>
            <input
              className="form-control"
              disabled={disabled}
              id={name}
              name={name}
              type="file"
              accept="image/png, image/gif, image/jpg, image/jpeg, image/webp"
              onChange={(event) => {
                helpers.setValue(event.currentTarget.files[0]);
                handleImageChange(event);
              }}
            />
          </div>
          <div className={meta.error ? 'is-invalid' : ''} />
          {meta.error && <div className="invalid-feedback">{meta.error}</div>}
          {thumb ? (
            <img
              src={thumb}
              alt={field.value?.name || ''}
              className="img-thumbnail tw-mt-2"
              height={152}
              width={152}
            />
          ) : (
            <div className="avatar-placeholder">
              <div className="avatar-name">{avatarName}</div>
            </div>
          )}
          <div className="hint">{hint || 'Photo'}</div>
        </Col>
      </Row>
    </div>
  );
};

export default ImageFieldWithAvatar;
